<template>
	<Stepper @onStepChange="handleStepChange" @onFinishStepper="submitData">
		<template v-if="step == 0">
			<Step1
				@updated="updateData"
				class="sscw-step step-1 sscw-container sscw-flex-column"
				@onValidation="handleValidation"
			/>
		</template>

		<template v-if="step == 1">
			<Step3 @updated="updateData" class="sscw-step step-2" @onValidation="handleValidation" />
		</template>

		<template v-if="step == 2">
			<Step4
				@updated="updateData"
				class="sscw-step step-3 sscw-container sscw-flex-column"
				@onValidation="handleValidation"
			/>
		</template>

		<template v-if="step == 3">
			<Step5
				@updated="updateData"
				:appraisalValue="sendData.appraisalValue"
				:increasePerYear="increasePerYear"
				:years="sendData.years"
				class="sscw-step step-4 sscw-container sscw-flex-column"
			/>
		</template>

		<template v-if="step == 3.5">
			<stepLoading @onValidation="handleValidation" />
		</template>

		<template v-if="step == 4">
			<Step6
				@updated="updateData"
				@onValidation="handleValidation"
				class="sscw-step step-5 sscw-container sscw-flex-column"
			/>
		</template>

		<template v-if="step == 5">
			<Step2
				@updated="updateData"
				class="sscw-step step-1 sscw-container sscw-flex-column"
				@onValidation="handleValidation"
			/>
		</template>
	</Stepper>
</template>

<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
import VueCurrencyInput from "vue-currency-input";
import "vue-slider-component/theme/default.css";
import store from "@/stores";

Vue.use(VTooltip);
Vue.use(VueCurrencyInput);

store(Vue);

import Step1 from "@/components/wizardExtn/steps/Step1.vue";
import Step2 from "@/components/wizardExtn/steps/Step2.vue";
import Step3 from "@/components/wizardExtn/steps/Step3.vue";
import Step4 from "@/components/wizardExtn/steps/Step4.vue";
import stepLoading from "@/components/wizardExtn/steps/StepLoading.vue";
import Step5 from "@/components/wizardExtn/steps/Step5.vue";
import Step6 from "@/components/wizardExtn/steps/Step6.vue";
import Stepper from "@/components/wizardExtn/Stepper.vue";
import getTheme from "@/utils/theme";

getTheme();

export default {
	components: {
		Step1,
		Step2,
		Step3,
		Step4,
		stepLoading,
		Step5,
		Step6,
		Stepper,
	},
	data() {
		return {
			progress: 40,
			step: null,
			maxStep: 5,
			transition: "slide-next",
			houseType: null,
			increasePerYear: 0.0225,
			appraisalValue: 1100000,
			years: 9,

			sendData: {},
		};
	},
	computed: {
		houseTypeComputed() {
			return this.$store.testingState;
		},
		wizardState() {
			return this.$store.wizardState;
		},
	},
	created() {
		let urlParams = new URLSearchParams(window.location.search);
		this.houseType = urlParams.get("houseType");

		this.$store.wizardState.houseType = urlParams.get("houseType");
		this.$store.isCurrentStepValid = "EXTN";
	},
	mounted() {},
	watch: {},
	methods: {
		handleValidation(validationStatus) {
			this.$store.isCurrentStepValid = validationStatus;
		},
		handleStepChange(navigation) {
			this.step = navigation.step;
		},
		updateData(updatedData) {
			this.sendData = { ...this.sendData, ...updatedData };
		},

		/* eslint-disable */
		submitData() {
			try {
				let house_type = document.getElementsByName("house_type");
				house_type[0].value = this.houseType;

				let major_renovation = document.getElementsByName("major_renovation");
				major_renovation[0].value = "";

				let immobile_classification = document.getElementsByName("immobile_classification");
				immobile_classification[0].value = this.wizardState.immobileClassification;

				let house_construction = document.getElementsByName("house_construction");
				house_construction[0].value = this.wizardState.houseConstruction;

				let state = document.getElementsByName("sscw_state");
				state[0].value = this.wizardState.state;

				let zipCode = document.getElementsByName("sscw_zipcode");
				zipCode[0].value = this.wizardState.zipCode;

				let address = document.getElementsByName("sscw_address");
				address[0].value = this.wizardState.address;

				let house_value = document.getElementsByName("house_value");
				house_value[0].value = this.wizardState.appraisalValue;

				let encumbrances = document.getElementsByName("encumbrances");
				encumbrances[0].value = this.wizardState.existEncumbrances;

				let house_size = document.getElementsByName("house_size");
				house_size[0].value = this.wizardState.houseSize;

				let property_size = document.getElementsByName("property_size");
				property_size[0].value = this.wizardState.propertySize;

				let construction_year = document.getElementsByName("construction_year");
				construction_year[0].value = this.wizardState.constructionYear;

				let garage_space = document.getElementsByName("garage_space");
				garage_space[0].value = this.wizardState.garageSpace;

				let house_foundation = document.getElementsByName("house_foundation");
				house_foundation[0].value = this.wizardState.houseFoundation;

				let years = document.getElementsByName("years");
				years[0].value = "";

				let desired_rent = document.getElementsByName("desired_rent");
				desired_rent[0].value = "";

				let initial_payout = document.getElementsByName("initial_payout");
				initial_payout[0].value = this.wizardState.initialPayout;

				let investment_amount = document.getElementsByName("investment_amount");
				investment_amount[0].value = "";

				let salutation = document.getElementsByName("salutation");
				if (this.wizardState.salutation == "Herr") salutation[0].value = "Mr.";
				if (this.wizardState.salutation == "Frau") salutation[0].value = "Ms.";

				let salutation_german = document.getElementsByName("german_salutation");
				salutation_german[0].value = this.wizardState.salutation;

				let name = document.getElementsByName("sscw_name");
				name[0].value = this.wizardState.name;

				let phone_number = document.getElementsByName("sscw_phone_number");
				phone_number[0].value = this.wizardState.phone;

				let email = document.getElementsByName("sscw_email");
				email[0].value = this.wizardState.email;

				let moreInfo = document.getElementsByName("sscw_moreinfo");
				moreInfo[0].value = this.wizardState.moreInfo;

				let digitalNotification = document.getElementsByName("sscw_digital_notification");
				digitalNotification[0].value = this.wizardState.digitalNotification;

				let pdfNotification = document.getElementsByName("sscw_pdf_notification");
				pdfNotification[0].value = this.wizardState.pdfNotification;

				let requestOffer = document.getElementsByName("sscw_request_offer");
				requestOffer[0].value = this.wizardState.requestOffer;

				let utm_ab_variant = document.getElementsByName("utm_ab_variant");
				utm_ab_variant[0].value = "EXTN";

				let custom_submit_button_12_1 = document.getElementsByName("custom_submit_button-12_1");
				custom_submit_button_12_1[0].click();
			} catch (error) {
				console.error(error);
			}
		},
		displayInEuro: (v) => `\u20AC ${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
	},
};
</script>

<style>
@import url(../styles/global.css);
@import url(../styles/new-wizard.css);
@import url(../../node_modules/vue-select/dist/vue-select.css);
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Anek+Latin:wght@100..800&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

>>> {
	--vs-colors--lightest: rgba(60, 60, 60, 0.26);
	--vs-colors--light: rgba(60, 60, 60, 0.5);
	--vs-colors--dark: #333;
	--vs-colors--darkest: rgba(0, 0, 0, 0.15);

	/* Search Input */
	--vs-search-input-color: inherit;
	--vs-search-input-bg: rgb(255, 255, 255);
	--vs-search-input-placeholder-color: inherit;

	/* Font */
	--vs-font-size: 1rem;
	--vs-line-height: 1.4;

	/* Disabled State */
	--vs-state-disabled-bg: rgb(248, 248, 248);
	--vs-state-disabled-color: var(--vs-colors--light);
	--vs-state-disabled-controls-color: var(--vs-colors--light);
	--vs-state-disabled-cursor: not-allowed;

	/* Borders */
	--vs-border-color: var(--vs-colors--lightest);
	--vs-border-width: 1px;
	--vs-border-style: solid;
	--vs-border-radius: 4px;

	/* Actions: house the component controls */
	--vs-actions-padding: 4px 6px 0 3px;

	/* Component Controls: Clear, Open Indicator */
	--vs-controls-color: var(--vs-colors--light);
	--vs-controls-size: 1;
	--vs-controls--deselect-text-shadow: 0 1px 0 #fff;

	/* Selected */
	--vs-selected-bg: #f0f0f0;
	--vs-selected-color: var(--vs-colors--dark);
	--vs-selected-border-color: var(--vs-border-color);
	--vs-selected-border-style: var(--vs-border-style);
	--vs-selected-border-width: var(--vs-border-width);

	/* Dropdown */
	--vs-dropdown-bg: #fff;
	--vs-dropdown-color: inherit;
	--vs-dropdown-z-index: 1000;
	--vs-dropdown-min-width: 160px;
	--vs-dropdown-max-height: 350px;
	--vs-dropdown-box-shadow: 0px 3px 6px 0px var(--vs-colors--darkest);

	/* Options */
	--vs-dropdown-option-bg: #000;
	--vs-dropdown-option-color: var(--vs-dropdown-color);
	--vs-dropdown-option-padding: 3px 20px;

	/* Active State */
	--vs-dropdown-option--active-bg: #5897fb;
	--vs-dropdown-option--active-color: #fff;

	/* Deselect State */
	--vs-dropdown-option--deselect-bg: #fb5858;
	--vs-dropdown-option--deselect-color: #fff;

	/* Transitions */
	--vs-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
	--vs-transition-duration: 150ms;
}
</style>
